"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DeleteReviewFromReviewCycleParams () {
        return DeleteReviewFromReviewCycleParams;
    },
    get ExportReviewCycleReviewReportsDetailsBody () {
        return ExportReviewCycleReviewReportsDetailsBody;
    },
    get ExportReviewCycleReviewReportsDetailsParams () {
        return ExportReviewCycleReviewReportsDetailsParams;
    },
    get PostReviewCycleCalculateBody () {
        return PostReviewCycleCalculateBody;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _lambdas = require("../lambdas");
const PostReviewCycleCalculateBody = _zod.z.object({
    reviewCycleId: _utilsisomorphic.transformObjectId,
    actions: _lambdas.ReviewCycleCalculateHandlerEvent.shape.actions
});
const DeleteReviewFromReviewCycleParams = _zod.z.object({
    reviewCycleId: _utilsisomorphic.transformObjectId,
    reviewId: _utilsisomorphic.transformObjectId
});
const ExportReviewCycleReviewReportsDetailsParams = _zod.z.object({
    reviewCycleId: _utilsisomorphic.transformObjectId
});
const ExportReviewCycleReviewReportsDetailsBody = _zod.z.object({
    timezone: _zod.z.string().optional()
});
